module.exports = "/images/vtex.png?d219a05ee79d81606ecb3de6f6b54cf5";